import * as React from 'react'
import classNames from 'classnames'
import { useNavigate } from 'react-router-dom'

import { Content } from 'sdk/components/content/Content'
import { ExploreProductCard } from 'sdk/explore-product-card/ExploreProductCard'

import soundcoreImage from './assets/soundcode-explore-bg.jpg'
import soundscapeImage from './assets/soundscape-explore-bg.jpg'

import classes from './style.module.scss'

const isExternalUrl = (url: string): boolean => /^(https?:\/\/|mailto:|tel:)/.test(url)

interface ComponentProps {
  className?: string
  soundcoreTitle?: string
  soundcoreButtonText?: string
  soundcoreButtonUrl?: string
  soundscapeTitle?: string
  soundscapeButtonText?: string
  soundscapeButtonUrl?: string
}

export const ExploreProductsSection: React.FC<ComponentProps> = (props) => {
  const {
    className,
    soundcoreTitle = 'Learn more about the Soundcore SDK for Pro Audio',
    soundcoreButtonText = 'Explore Soundcore',
    soundcoreButtonUrl = '/soundcore',
    soundscapeTitle = 'Learn more about the Soundscape SDK for Automotive',
    soundscapeButtonText = 'Explore Soundscape',
    soundscapeButtonUrl = '/soundscape',
  } = props
  const navigate = useNavigate()

  const handleSoundcoreClick = (): void => {
    if (isExternalUrl(soundcoreButtonUrl)) {
      window.location.assign(soundcoreButtonUrl)
      return
    }

    navigate(soundcoreButtonUrl)
  }

  const handleSoundscapeClick = (): void => {
    if (isExternalUrl(soundscapeButtonUrl)) {
      window.location.assign(soundscapeButtonUrl)
      return
    }

    navigate(soundscapeButtonUrl)
  }

  return (
    <Content className={classNames(classes.container, className)}>
      <ExploreProductCard
        title={soundcoreTitle}
        buttonText={soundcoreButtonText}
        background={soundcoreImage}
        onButtonClick={handleSoundcoreClick}
      />
      <ExploreProductCard
        title={soundscapeTitle}
        buttonText={soundscapeButtonText}
        background={soundscapeImage}
        onButtonClick={handleSoundscapeClick}
      />
    </Content>
  )
}

ExploreProductsSection.defaultProps = {
  className: undefined,
  soundcoreTitle: undefined,
  soundcoreButtonText: undefined,
  soundcoreButtonUrl: undefined,
  soundscapeTitle: undefined,
  soundscapeButtonText: undefined,
  soundscapeButtonUrl: undefined,
}
